import { Component, OnInit, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-fsce',
  imports: [  CommonModule,

    FormsModule,

    RouterModule],
  templateUrl: './fsce.component.html',
  styleUrl: './fsce.component.css',
})
export class FsceComponent {
  openAccordions: { [key: string]: boolean } = {
    english: true,
    maths:   true,
    writing: true
  };
 
  schools: string[] = [
    'Reading School',
    'Chelmsford County High School for Girls',
    'Ermysted\'s Grammar School',
    'Heckmondwike Grammar School',
    'Lancaster Girls\' Grammar School',
    'Skipton Girls\' High School',
    'North Halifax Grammar School',
    'The Crossley Heath School',
    'Clitheroe Royal Grammar School'
  ];
 
  papers: Array<{
    num: string; barClass: string; numClass: string;
    title: string; desc: string; tagText: string; tagClass: string;
  }> = [
    {
      num: 'Adventure Paper', barClass: 'fsce-bar-primary', numClass: 'fsce-co',
      title: 'Multiple Choice',
      desc: 'Covers any KS2 subject up to Year 5. Students select from multiple choice answer options A–D and mark their answers on a separate answer sheet.',
      tagText: 'Any KS2 Subject', tagClass: 'fsce-tag-primary'
    },
    {
      num: 'Beacon Paper', barClass: 'fsce-bar-dark', numClass: 'fsce-cn',
      title: 'Short Written Answers',
      desc: 'Covers any KS2 subject up to Year 5. Students write their responses directly in the spaces provided — showing clear reasoning and working where needed.',
      tagText: 'Written Response', tagClass: 'fsce-tag-dark'
    },
    {
      num: 'Compass Paper', barClass: 'fsce-bar-teal', numClass: 'fsce-ct',
      title: 'Multiple Choice',
      desc: 'A second multiple-choice paper covering any KS2 subject. Like the Adventure Paper, students select from options A–D on a separate answer sheet.',
      tagText: 'Any KS2 Subject', tagClass: 'fsce-tag-teal'
    },
    {
      num: 'Discovery Paper', barClass: 'fsce-bar-gold', numClass: 'fsce-ca',
      title: 'Creative Response',
      desc: 'Tests imaginative flair and original thinking — the ability to think of new ideas or solve problems in unique ways. No prior topic can be predicted.',
      tagText: 'Creativity & Reasoning', tagClass: 'fsce-tag-gold'
    }
  ];

  // kept for backward compat but replaced by papers above
  extPapers: Array<{ name: string; desc: string }> = [
    { name: 'Adventure Paper', desc: 'Multiple-choice · Any KS2 subject' },
    { name: 'Beacon Paper',    desc: 'Short written-response questions' },
    { name: 'Compass Paper',   desc: 'Second multiple-choice paper' },
    { name: 'Discovery Paper', desc: 'Creative task · imagination & reasoning' }
  ];
 
  markingCards: Array<{ bgClass: string; title: string; desc: string }> = [
    {
      bgClass: 'fsce-bg-primary',
      title: 'OMR Technology',
      desc: 'Multiple-choice papers are marked electronically using Optical Mark Recognition — fast, accurate and consistent.'
    },
    {
      bgClass: 'fsce-bg-secondary',
      title: 'Age-Standardised Scores',
      desc: 'A child\'s age at test time is taken into account, so summer-born children are not disadvantaged against older peers.'
    },
    {
      bgClass: 'fsce-bg-gold',
      title: 'Academic Papers Come First',
      desc: 'The creative writing paper is only marked if the student first meets the required standard in English and Maths.'
    }
  ];
 
  ks2Subjects: string[] = [
    'Art & Design', 'Computing', 'Design & Technology', 'English',
    'Geography', 'History', 'Languages', 'Maths', 'Music',
    'Physical Education', 'Science'
  ];
 
  prepSteps: Array<{ num: string; title: string; desc: string }> = [
    {
      num: '01',
      title: 'Build Strong KS2 Foundations',
      desc: 'The FSCE tests application of knowledge up to the end of Year 5 only — nothing extra or new is introduced. Short, regular sessions consolidating KS2 curriculum are far more effective than last-minute cramming.'
    },
    {
      num: '02',
      title: 'Encourage Daily Reading',
      desc: 'Reading a wide mix of fiction and non-fiction regularly builds vocabulary, comprehension, inference skills, and confidence with unfamiliar texts — all central to the FSCE.'
    },
    {
      num: '03',
      title: 'Practise Application, Not Just Recall',
      desc: 'The FSCE is more focused on how children apply what they know than on recalling facts. Practise using knowledge across different subjects and contexts, and build creative thinking skills.'
    },
    {
      num: '04',
      title: 'Focus on Progress',
      desc: 'Celebrate small achievements to keep motivation high. Note: there are no FSCE-authorised past papers or practice papers, so practising under realistic timed conditions — as we do at Sehyog — is especially important.'
    }
  ];
 
  ctaSubjects: Array<{ title: string; sub: string }> = [
    { title: 'English',          sub: 'Comprehension · Vocabulary · Spelling' },
    { title: 'Maths',            sub: 'Number · Geometry · Statistics' },
    { title: 'Creative Writing', sub: 'Structure · Vocabulary · Pace' },
    { title: 'Mock Tests',       sub: 'Real FSCE-style conditions' }
  ];
 
  constructor(private router: Router, private elRef: ElementRef) {}
 
  ngOnInit(): void {
    setTimeout(() => this.checkReveal(), 120);
  }
 
  ngOnDestroy(): void {}
 
  toggleAccordion(key: string): void {
    this.openAccordions[key] = !this.openAccordions[key];
  }
 
  @HostListener('window:scroll')
  onScroll(): void { this.checkReveal(); }
 
  private checkReveal(): void {
    const els = this.elRef.nativeElement.querySelectorAll('.fsce-reveal, .fsce-rl, .fsce-rr');
    const wh = window.innerHeight;
    els.forEach((el: Element) => {
      if (el.getBoundingClientRect().top < wh * 0.9) {
        el.classList.add('fsce-vis');
      }
    });
  }
 
  scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }
 
  goToContact(): void { this.router.navigate(['/contact']); }
  goToCourses(): void { this.router.navigate(['/courses']); }
  goToHome(): void    { this.router.navigate(['/']); }
}